__webpack_require__.p = "https://api-gaming.paviliononline.io/sdk/";